"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawPlane = void 0;
var comma = function (n) {
    return (Math.round(n * 100) / 100).toLocaleString();
};
var getLegendWidth = function (boxMargin, fontSize) { return function (legend, i) {
    var BOX_WIDTH = 60;
    var labelWidth = legend.text.split("").map(function (it) { var _a; return (!((_a = it.match(/[A-Za-z0-9()\- &#+]/)) === null || _a === void 0 ? void 0 : _a.length)) ? fontSize * 2 : fontSize; }).reduce(function (acc, it) { return acc + it; }, 0); // is chinese char
    return labelWidth + BOX_WIDTH + boxMargin;
}; };
var flowLeft = function (legnedWidths, lineWidth) {
    var rows = [];
    var lastX = 0;
    var createNewRow = function (i) {
        rows.push([i]);
    };
    var pushToLastRow = function (i) {
        if (!rows.length) {
            createNewRow(i);
        }
        else {
            rows[rows.length - 1].push(i);
        }
    };
    for (var i = 0; i < legnedWidths.length; i++) {
        if (lastX + legnedWidths[i] > lineWidth) {
            createNewRow(legnedWidths[i]);
        }
        else {
            pushToLastRow(legnedWidths[i]);
        }
    }
    return rows;
};
var getLegendXy = function (legendWidths, lineWidth, lineHeight) {
    var legendXs = legendWidths.reduce(function (acc, it, i) {
        if (i === 0)
            return acc;
        acc[i] = acc[i - 1] + it;
        return acc;
    }, legendWidths);
    var xRows = flowLeft(legendXs, lineWidth);
    var xys = xRows.map(function (row, i) {
        return row.map(function (x, j) { return [j === 0 ? 0 : row[j - 1], i * lineHeight]; });
    }).flatMap(function (it) { return it; });
    return function (_, i) { return xys[i]; };
};
var drawLegend = function (svg, xMargin, yMargin, fontSize, boxMargin, lineWidth, lineHeight, legendXys) {
    return function (legend, i) {
        var _a = legendXys[i], x = _a[0], y = _a[1];
        var legendColor = legend.textColor || '#777';
        svg.line(x + xMargin, y + fontSize + yMargin, x + lineWidth + xMargin, y + fontSize + yMargin)
            .stroke({ width: lineHeight, color: legend.color });
        svg.text(function (tspan) { return tspan.move(x + lineWidth + boxMargin + xMargin, y + yMargin)
            .text(legend.text)
            .attr({ 'class': 'legend' })
            .font({ size: fontSize, 'font-family': 'monospace', 'font-weight': 'bold', fill: legendColor }); });
    };
};
var drawPlane = function (svg, config, dataPoints, yAxisMarks, destPlane) {
    var LABEL_OFFSET = 18;
    var thickness = config.thickness || 0;
    var bgLineColor = config.backgroundLineColor || '#eee';
    var bgLineWidth = config.backgroundLineWidth || 1;
    var labelGap = 20;
    var innerPaddingStart = config.xAxis.innerPaddingStart || 0;
    svg.rect('100%', '100%').fill({ color: config.backgroundColor ? config.backgroundColor : 'transparent' });
    var yFontSize = config.yAxis.fontSize || 30;
    var xFontSize = config.xAxis.fontSize || 30;
    var yLabelColor = config.yAxis.labelColor || '#000';
    var yAxisWidth = 1;
    var yFixMax = config.yAxis.fixMax;
    var availableYAxisMarks = yAxisMarks.filter(function (it) { return (yFixMax && yFixMax > 0) ? it[0] <= yFixMax : it; });
    availableYAxisMarks.map(function (it) {
        svg.line(config.xAxis.marginStart, it[1], config.width - config.xAxis.marginEnd, it[1])
            .stroke({ width: bgLineWidth, color: bgLineColor });
        var labelX = config.yAxis.right ? config.width - config.xAxis.marginEnd + labelGap : config.xAxis.marginStart - labelGap;
        var labelY = it[1] - yFontSize;
        var label = svg.text(function (tspan) { return tspan.move(labelX, labelY)
            .font('anchor', config.yAxis.right ? 'start' : 'end')
            .text("" + comma(it[0])); }).font({ size: yFontSize, fill: yLabelColor });
        if (labelY + 100 > config.height) {
            label.font({ fill: 'transparent' });
        }
    });
    if (!(config.xAxis.hidden || false)) {
        var xLabelColor_1 = config.xAxis.labelColor || '#000';
        var xLabelWidthMultiplyer = config.xAxis.xLabelWidthMultiplyer || 1.6;
        var LABEL_WIDTH_1 = config.xAxis.series[0].toString().split("\n")[0].length * xFontSize * xLabelWidthMultiplyer;
        var lastLabelPos_1 = 0;
        var dataPoints2 = config.type === 'range' ? dataPoints.map(function (it) { return it[0]; }) : dataPoints;
        var isVertical_1 = config.xAxis.vertical;
        dataPoints2.map(function (it, i) {
            var current = it[0] - config.xAxis.marginStart;
            if (!isVertical_1 && current != 0 && lastLabelPos_1 + LABEL_WIDTH_1 > current)
                return;
            lastLabelPos_1 = current;
            var strokeWidth = 1;
            var tx = innerPaddingStart + yAxisWidth + strokeWidth + it[0] + (thickness / 2);
            var ty = destPlane[0][0][1];
            var t = svg.text(function (tspan) { return tspan.move(tx, ty)
                .text(config.xAxis.series[i]); }).font({ size: xFontSize, fill: xLabelColor_1, anchor: isVertical_1 ? 'start' : 'middle' });
            if (isVertical_1)
                t.attr({ 'transform': "rotate(45, " + tx + ", " + ty + ") translate(10,-" + xFontSize * 0.7 + ")", });
            svg.line(innerPaddingStart + yAxisWidth + strokeWidth + it[0] + thickness / 2, ty, innerPaddingStart + yAxisWidth + strokeWidth + it[0] + thickness / 2, ty + xFontSize * 0.4).stroke({ color: config.xAxis.color, width: strokeWidth });
        });
    }
    svg.line(destPlane[1]).stroke({ color: config.yAxis.color, width: yAxisWidth });
    if (!(config.xAxis.hidden || false)) {
        svg.line(destPlane[0]).stroke({ color: config.xAxis.color, width: yAxisWidth });
    }
    if (config.yAxis.label) {
        if (config.yAxis.labelIsVertical) {
            if (config.yAxis.right) {
                var labelX = destPlane[0][1][0] || LABEL_OFFSET;
                var labelY = yAxisMarks[yAxisMarks.length - 1][1];
                svg.text(function (tspan) { return tspan
                    .transform({ rotate: 270, translateX: config.xAxis.marginEnd / 2.4, translateY: 0, origin: [labelX, labelY] })
                    .move(labelX, labelY)
                    .text(config.yAxis.label)
                    .font({ size: yFontSize, fill: yLabelColor, anchor: 'start' }); });
            }
            else {
                var labelX = config.yAxis.labelX || LABEL_OFFSET;
                var labelY = yAxisMarks[0][1] + (yAxisMarks[yAxisMarks.length - 1][1] - yAxisMarks[0][1]) / 2;
                svg.text(function (tspan) { return tspan
                    .transform({ rotate: 270, translateX: 0 - yFontSize, translateY: 0, origin: [labelX, labelY] })
                    .move(labelX, labelY)
                    .text(config.yAxis.label)
                    .font({ size: yFontSize, fill: yLabelColor, anchor: 'middle' }); });
            }
        }
        else {
            if (config.yAxis.right) {
                var labelX = destPlane[0][1][0] || LABEL_OFFSET;
                var labelY = config.yAxis.labelY || LABEL_OFFSET;
                svg.text(function (tspan) { return tspan.move(labelX, labelY)
                    .text(config.yAxis.label)
                    .font({ size: yFontSize, fill: yLabelColor, anchor: 'middle' }); });
            }
            else {
                var labelX = config.yAxis.labelX || LABEL_OFFSET;
                var labelY = config.yAxis.labelY || LABEL_OFFSET;
                svg.text(function (tspan) { return tspan.move(labelX, labelY)
                    .text(config.yAxis.label)
                    .font({ size: yFontSize, fill: yLabelColor }); });
            }
        }
    }
    if (config.xAxis.label) {
        var LINE_HEIGHT_1 = (xFontSize + 8) * config.xAxis.series[0].split('\n').length;
        svg.text(function (tspan) { return tspan.move(destPlane[0][0][0] + ((destPlane[0][1][0] - destPlane[0][0][0]) / 2), destPlane[0][1][1] + LINE_HEIGHT_1)
            .text(config.xAxis.label)
            .font({ size: xFontSize, anchor: 'end' }); });
    }
    if (config.legends && config.legends.length) {
        var legends = config.legends;
        var LINE_WIDTH = 40;
        var LEGEND_HEIGHT = 30;
        var LINE_HEIGHT = 12;
        var BOX_MARGIN = 20;
        var drawableWidth = config.width - (config.xAxis.marginEnd * 2);
        var legendWidths = legends.map(getLegendWidth(BOX_MARGIN, yFontSize / 1.6)); // calculate label width by text
        var legendXys = legends.map(getLegendXy(legendWidths, drawableWidth, LEGEND_HEIGHT)); // calculate x,y by text
        legends.map(drawLegend(svg, config.xAxis.marginStart, 0, yFontSize, BOX_MARGIN, LINE_WIDTH, LINE_HEIGHT, legendXys));
    }
};
exports.drawPlane = drawPlane;
